// extracted by mini-css-extract-plugin
export default {"content":"czKLbka7r1","message-icon":"yXqnE6qo6B","messageIcon":"yXqnE6qo6B","not-available":"C4SDDjosGi","notAvailable":"C4SDDjosGi","messages":"kewILYkdo9"};